import Avatar from "shared-web/src/components/Avatar/index"

import styles from './style.styl'

const CurrentTeamMembers = ({
  usersAndProperties,
  sendExistingUsersInvitationsViaEmail,
  sendInvitationsViaEmail,
}) => (
  <div className={styles.CurrentTeamMembers}>
    <div className="dsg-Title container-header">Send the Drift extension to your teammates </div>
    <div className="team-members-table">
      <div className="team-members-table-header">Team Member</div>
      <div className="team-members-table-body">
        {usersAndProperties
          .filter(({ installed }) => !installed)
          .map(({ user, invited }) => (
            <div className="team-members-table-row" key={user.id}>
              <div className="team-members-table-row-avatar">
                <Avatar className="existing-extension-avatar" user={user} />
              </div>
              <div className="flex-column">
                {user.name && <div className="dsg-Title name">{user.name}</div>}
                <div className="dsg-Title email">{user.email}</div>
              </div>
              <button
                className="team-members-table-row-send drift-button medium"
                onClick={() => { 
                  user.status === 'INVITED'
                  ? sendInvitationsViaEmail(user.email)
                  : sendExistingUsersInvitationsViaEmail(user.id) }}
              >
                { invited ? 'Resend Extension' : 'Send Invitation' }
              </button>
            </div>
          ))}
      </div>
    </div>
  </div>
)

export default CurrentTeamMembers



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ExtensionInviteModal/CurrentTeamMembers/component.js